<template>
  <v-form ref="form" class="d-flex align-center" @submit.prevent="onSubmit">
    <v-text-field
      v-model="theText"
      class="mx-2 flex-grow-1"
      outlined
      hide-details
      clearable
      xlabel=""
      label="Pesquise por classe, assunto, competência ou texto da sentença"
    />
    <v-btn type="submit" color="primary" dark large>
      Buscar
    </v-btn>
  </v-form>
</template>

<script>
import Vue from "vue";

export default Vue.component("tj-search-bar", {
  props: {
    text: String
  },

  data() {
    return {
      theText: this.text
    };
  },

  watch: {
    text(v) {
      this.theText = v;
    }
  },

  methods: {
    onSubmit() {
      this.$emit("search", this.theText);
    }
  }
});
</script>
